import { el } from '../core/dom.js';

/**
 * @param {{ kicker?: string, title?: string, body?: unknown, footer?: unknown }} opts
 */
export function card(opts) {
  return el('section', { class: 'card' },
    opts.kicker ? el('p', { class: 'kicker' }, opts.kicker) : null,
    opts.title ? el('h2', { class: 'card-title' }, opts.title) : null,
    opts.body != null ? el('div', { class: 'card-body' }, opts.body) : null,
    opts.footer != null ? el('div', { class: 'card-foot' }, opts.footer) : null);
}
